import { DashboardWidgetType } from 'features/dashboard/types'
import { InsightData } from 'schemas/action/InsightDataSchema'
import LogoPrecision from 'enums/LogoPrecision'
import { CVLogo } from 'schemas/CVLogoSchema'
import { WidgetSettingComposingStrategy } from './widgetSettingComposingStrategy'
import MAX_INPUT_COUNT from './constants'

const canBeDrilledDown = (widgetSetting: DashboardWidgetType) =>
  widgetSetting.cvLogos === undefined ||
  widgetSetting.cvLogos === null ||
  widgetSetting.cvLogos.length === 0

const isOverMaxInput = (insights: InsightData[]) => insights.length > MAX_INPUT_COUNT

const composeDrillDownWidgetSetting = (
  widgetSetting: DashboardWidgetType,
  insights: InsightData[]
) => {
  const cvLogo: CVLogo = {
    logoTypes: insights.map((insight) => insight.enumName),
    logoPrecisions: [LogoPrecision.LOW, LogoPrecision.MEDIUM, LogoPrecision.HIGH]
  }
  return {
    ...widgetSetting,
    cvLogos: [cvLogo]
  }
}

const generateCvLogosStrategy = (): WidgetSettingComposingStrategy => ({
  canBeDrilledDown,
  isOverMaxInput,
  composeDrillDownWidgetSetting
})

export default generateCvLogosStrategy
